module.exports = __webpack_public_path__ + "img/fabrica-2.cf58d407.jpeg";